import { render, staticRenderFns } from "./DialogAddMarketingBudget.vue?vue&type=template&id=552cf4d9&scoped=true"
import script from "./DialogAddMarketingBudget.vue?vue&type=script&lang=js"
export * from "./DialogAddMarketingBudget.vue?vue&type=script&lang=js"
import style0 from "./DialogAddMarketingBudget.vue?vue&type=style&index=0&id=552cf4d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552cf4d9",
  null
  
)

export default component.exports